<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         form: {
            tahun: new Date(this.$store.state.DashboardSicantik.tahun, 0, 1),
         },
         isRefreshing: false,
      }
   },
   computed: {
      ...mapState({
         myData: state => state.DashboardSicantik.stattistik,
         tahun: state => state.DashboardSicantik.tahun,
      }),
      getThisYear() {
         return this.tahun
      },
      statisticCards() {
         return [
            {
               key: 'izin_year',
               icon: 'AwardIcon',
               title: `Izin Terbit Tahun ${this.getThisYear}`,
               description: 'Izin yang telah terbit tahun ini',
               color: 'success',
            },
            {
               key: 'izin_month',
               icon: 'CalendarIcon',
               title: 'Izin Terbit Bulan Ini',
               description: 'Izin yang telah terbit bulan ini',
               color: 'info',
            },
            {
               key: 'izin_proses',
               icon: 'ClockIcon',
               title: 'Sedang Diproses',
               description: 'Izin yang sedang dalam proses',
               color: 'warning',
            },
         ]
      },
   },
   watch: {
      'form.tahun': function onYearChanged(newYear) {
         if (newYear) this.refreshStatistics(newYear)
      },
   },
   mounted() {
      this.refreshStatistics(this.form.tahun)
   },
   methods: {
      async refreshStatistics(year) {
         if (this.isRefreshing) return

         this.isRefreshing = true
         try {
            await this.getSicantik(year)
         } finally {
            this.isRefreshing = false
         }
      },
      async handleRefreshClick() {
         await this.refreshStatistics(this.form.tahun)
         this.triggerRefresh()
      },
      formatStatistic(value) {
         return Number(value || 0).toLocaleString('id-ID')
      },
      ...mapActions({
         getSicantik: 'DashboardSicantik/getStatistik',
         triggerRefresh: 'DashboardSicantik/triggerRefresh',
      }),
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card no-body class="statistics-wrapper overflow-hidden">
            <div class="statistics-heading p-2 p-md-2 d-flex flex-wrap align-items-center justify-content-between">
               <div class="d-flex align-items-center">
                  <div class="logo-wrapper mr-1 mr-md-2">
                     <b-img
                        :src="require('@/assets/images/logo/sicantik.png')"
                        alt="Logo SICANTIK"
                        height="54"
                        class="img-fluid"
                     />
                  </div>
                  <div>
                     <h3 class="text-white mb-25">
                        SICANTIK
                     </h3>
                     <p class="text-white mb-0 statistics-subtitle">
                        Ringkasan statistik Sistem Informasi CANTIK
                     </p>
                  </div>
               </div>
               <div class="oss-toolbar d-flex align-items-end mt-1 mt-md-0">
                  <b-form-group class="mb-0 mr-1">
                     <datepicker
                        id="dashboard-sicantik-tahun"
                        v-model="form.tahun"
                        :minimum-view="'year'"
                        :maximum-view="'year'"
                        format="yyyy"
                        input-class="datepicker-here form-control"
                        :disabled="isRefreshing"
                     />
                  </b-form-group>
                  <b-button
                     variant="light"
                     class="d-flex align-items-center"
                     :disabled="isRefreshing"
                     title="Muat ulang data"
                     @click="handleRefreshClick"
                  >
                     <b-spinner v-if="isRefreshing" small class="mr-50" />
                     <feather-icon v-else icon="RefreshCwIcon" class="mr-50" />
                     Refresh
                  </b-button>
               </div>
            </div>

            <b-card-body class="p-1 p-md-2">
               <b-row>
                  <b-col
                     v-for="stat in statisticCards"
                     :key="stat.key"
                     cols="12"
                     sm="6"
                     xl="4"
                     class="mb-1"
                  >
                     <b-card no-body class="statistic-card h-100">
                        <b-card-body class="d-flex align-items-start p-1-5">
                           <div :class="['statistic-icon', `icon-${stat.color}`]">
                              <feather-icon :icon="stat.icon" size="20" />
                           </div>
                           <div class="ml-1 flex-grow-1">
                              <div class="statistic-value">
                                 {{ formatStatistic(myData[stat.key]) }}
                              </div>
                              <h5 class="statistic-title mb-25">
                                 {{ stat.title }}
                              </h5>
                              <small class="text-muted">{{ stat.description }}</small>
                           </div>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>
            </b-card-body>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.statistics-wrapper {
   border: 0;
   border-radius: 12px;
   background-color: #ffffff;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.statistics-heading {
   background: linear-gradient(135deg, #003083 0%, #004299 100%);
}

.logo-wrapper {
   width: 64px;
   height: 64px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 5px;
   border-radius: 12px;
   background: rgba(255, 255, 255, 0.18);
}

.statistics-subtitle {
   opacity: 0.8;
   font-size: 0.85rem;
}

.statistic-card {
   border: 1px solid #ebe9f1;
   border-radius: 10px;
   transition: transform 0.2s ease, box-shadow 0.2s ease;
   margin-bottom: 0rem;
}

.statistic-card:hover {
   transform: translateY(-3px);
   box-shadow: 0 6px 16px rgba(34, 41, 47, 0.1);
}

.statistic-icon {
   width: 38px;
   height: 38px;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-shrink: 0;
   border-radius: 10px;
}

.icon-primary { color: #7367f0; background: #eeedff; }
.icon-success { color: #28c76f; background: #e5f8ed; }
.icon-info { color: #00cfe8; background: #e0f9fc; }
.icon-warning { color: #ff9f43; background: #fff3e5; }
.icon-danger { color: #ea5455; background: #fce8e8; }

.statistic-value {
   color: #5e5873;
   font-size: 1.35rem;
   font-weight: 700;
   line-height: 1.1;
}

.statistic-title {
   color: #5e5873;
   font-size: 0.9rem;
   line-height: 1.2;
}

.statistic-card small {
   font-size: 0.72rem;
   line-height: 1.15;
}

/* Dark layout overrides: keep card surfaces and text readable. */
.dark-layout .statistics-wrapper {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.dark-layout .statistic-card {
   border-color: #3b4253;
   background-color: #283046;
}

.dark-layout .statistic-value,
.dark-layout .statistic-title {
   color: #f6f6f6;
}

.dark-layout .statistic-card .text-muted {
   color: #b4b7bd !important;
}

.dark-layout .icon-primary { background: rgba(115, 103, 240, 0.2); }
.dark-layout .icon-success { background: rgba(40, 199, 111, 0.2); }
.dark-layout .icon-info { background: rgba(0, 207, 232, 0.2); }
.dark-layout .icon-warning { background: rgba(255, 159, 67, 0.2); }
.dark-layout .icon-danger { background: rgba(234, 84, 85, 0.2); }

.p-1-5 { padding: 1rem !important; }

@media (max-width: 575.98px) {
   .statistics-heading { padding: 1rem !important; }
   .p-1-5 { padding: 0.75rem !important; }
}
</style>
